import React from 'react';
import { testimonials } from '../data/teater';
export function Testimonials() {
  // Hidden until authentic TEATERKLAR reviews are added in data/teater.ts (no buyers yet)
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-293" data-mp="3fycqrnqb67bb">
      <div className="mx-auto max-w-6xl" data-id="element-294" data-mp="3azt0jb4om9d5">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-295" data-mp="36yzeyoepp6nf">
          Vad <em className="text-red-700" data-id="element-296" data-mp="3205yqo81j1jk">lärarna</em> säger
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-297" data-mp="321za2gtlm9xw">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-298" data-mp="2s1qbiwc4wcfc">
              <blockquote className="flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-299" data-mp="2s3t8k0bpf5tk">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-300" data-mp="qa3ot6z9z3oo">
                <span className="font-semibold text-slate-900" data-id="element-301" data-mp="q891jm0j6zhf">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-302" data-mp="h4dfoti1e27v"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}